// WorkflowHelpPage.js
import React from "react";
import { helpData } from "./helpData";

export default function WorkflowHelpPage() {
  const workflow = helpData.workflowGuide;

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title text-primary mb-3">{workflow.title}</h2>
          <p className="text-muted">{workflow.description}</p>

          {workflow.steps.map((s) => (
            <div key={s.step} className="mb-4">
              <h4 className="mb-3">
                <span className="badge bg-primary text-white me-2">Step {s.step} :  {s.title}</span>
               
              </h4>

              <ol className="list-group list-group-numbered">
                {s.details.map((d, i) => (
                  <li
                    key={i}
                    className="list-group-item d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">{i + 1}. {d}</div>
                  </li>
                ))}
              </ol>

              {/* {s.link && (
                <div className="mt-2">
                  <a
                    href={s.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    View Demo
                  </a>
                </div>
              )} */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
